import { colorPalette } from '../../colorPalette';
const RANK = {
    REGULAR: {
        label: 'Regular',
        order: 0,
        color: colorPalette.red800,
        icon: null,
    },
    SILVER: {
        label: 'Silver',
        order: 1,
        color: 'silver-dark',
        icon: null,
    },
    GOLD: {
        label: 'Gold',
        order: 2,
        color: 'gold-dark',
        icon: null,
    },
    PLATINUM: {
        label: 'Platinum',
        order: 3,
        color: 'platinum-dark',
        icon: null,
    },
};
const getRankFromString = (rankInString) => {
    const result = Object.entries(RANK).find(element => element[1].label === rankInString);
    return result ? result[1] : RANK.REGULAR;
};
const getRankFromOrder = (order) => {
    const result = Object.entries(RANK).find(element => element[1].order === order);
    return result ? result[1] : RANK.REGULAR;
};
export { RANK, getRankFromString, getRankFromOrder, };
